import { IconType } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";

export const STATUS_TO_TEXT_MAP = (status: string) => {
  switch (status) {
    case "new":
      return {
        displayText: "--",
      };
    case "verified":
      return {
        displayText: "Verified",
        iconType: "check" as IconType,
        iconColor: Colors.Success600,
      };
    case "invalid":
      return {
        displayText: "Invalid",
        iconType: "times-circle" as IconType,
        iconColor: Colors.Danger600,
      };
  }
};
